// src/components/LienUtile.js
import React, { useEffect, useState } from "react";
import { useTranslation } from 'react-i18next'; // AJOUT
import "../../CSS/LienUtile.css";
import { FaArrowUp } from "react-icons/fa";
import { useLanguageData } from '../../hooks/useLanguageData'; // Remplacer useApiProxy

function LienUtile() {
  const { t } = useTranslation(); // AJOUT: Hook de traduction
  const [links, setLinks] = useState([]);
  const [usaLink, setUsaLink] = useState(null);
  
  // Utiliser useLanguageData pour les liens utiles
  const { 
    data: linksResponse, 
    loading, 
    error 
  } = useLanguageData('/api/v1/embassy/useful-links-category?slugCategory=links_utiles_home');

  // Traiter les données quand elles arrivent
  useEffect(() => {
    if (linksResponse?.data && Array.isArray(linksResponse.data)) {
      console.log('🔗 Données liens utiles reçues (avec langue):', linksResponse);
      
      // Filtrer les liens pour exclure "Les Etats Unis d'Amérique" de la liste principale
      const mainLinks = linksResponse.data.filter(link => 
        link.slug !== 'etat-unis-amerique'
      );
      
      setLinks(mainLinks);
      
      // Chercher spécifiquement le lien USA
      const usaLinkData = linksResponse.data.find(link => 
        link.slug === 'etat-unis-amerique'
      );
      
      if (usaLinkData) {
        console.log('🇺🇸 Lien USA trouvé:', usaLinkData);
        setUsaLink(usaLinkData);
      } else {
        console.log('🇺🇸 Aucun lien USA trouvé');
        setUsaLink(null);
      }
    }
  }, [linksResponse]);

  // Fonction pour vérifier si l'image est valide (pas juste la racine du domaine)
  const isValidImage = (imageLogo) => {
    return imageLogo && 
           imageLogo !== 'https://api-diplomatie.olasoft.net/' && 
           imageLogo.startsWith('http') &&
           !imageLogo.endsWith('/'); // Exclure les URLs qui finissent par /
  };

  // Composant de spinner de chargement
  const LoadingSpinner = () => (
    <div className="lien-utile-container">
      <h2 className="lien-utile-title text-start">{t('lienUtile.title')}</h2>
      <div style={{ 
        display: 'flex', 
        justifyContent: 'center', 
        alignItems: 'center',
        height: '200px'
      }}>
        <div style={{
          width: "40px",
          height: "40px",
          border: "3px solid #f3f3f3",
          borderTop: "3px solid #1a3c5e",
          borderRadius: "50%",
          animation: "spin 1s linear infinite",
        }}></div>
      </div>
      
      <style>
        {`
          @keyframes spin {
            0% { transform: rotate(0deg); }
            100% { transform: rotate(360deg); }
          }
        `}
      </style>
    </div>
  );

  if (loading) {
    return <LoadingSpinner />;
  }

  if (error) {
    console.error('❌ Erreur lors du chargement des liens:', error);
    return (
      <div className="lien-utile-container">
        <h2 className="lien-utile-title text-start">{t('lienUtile.title')}</h2>
        <p style={{ textAlign: 'center', padding: '2rem', color: '#dc3545' }}>
          {t('common.error')}
        </p>
      </div>
    );
  }

  return (
    <div className="lien-utile-container">
      <h2 className="lien-utile-title text-start">{t('lienUtile.title')}</h2>

      <div className="lien-utile-grid1">
        {links.map((link) => (
          <div className="lien-utile-card" key={link.id}>
            <div className="lien-utile-card-content">
              {/* Afficher l'image UNIQUEMENT si elle est valide */}
              {isValidImage(link.imageLogo) ? (
                <img 
                  src={link.imageLogo} 
                  alt={link.name} 
                  className="lien-utile-logo"
                  onError={(e) => {
                    console.warn('❌ Image non chargée:', link.imageLogo);
                    e.target.style.display = 'none'; // Cacher l'image si erreur
                  }}
                />
              ) : (
                // Ne rien afficher si pas d'image valide
                <div style={{ height: '50px' }}></div> // Espace réservé
              )}
              <p className="lien-utile-text">{link.name}</p>
              <FaArrowUp className="lien-utile-icon" />
            </div>
            <a
              href={link.linkAccess}
              target="_blank"
              rel="noopener noreferrer"
              className="lien-utile-link-custom"
              style={{
                display: 'block',
                backgroundColor: '#1a3c5e',
                color: 'white',
                padding: '8px',
                textAlign: 'center',
                textDecoration: 'none',
                marginTop: '5px',
                marginBottom: "-10px",
                transition: 'all 0.3s ease'
              }}
            >
              {t('lienUtile.officialWebsite')}
            </a>
          </div>
        ))}

        {/* Affichage du lien USA directement dans la même grille */}
        {usaLink && (
          <div className="lien-utile-card" key="usa-link">
            <div className="lien-utile-card-content">
              {isValidImage(usaLink.imageLogo) ? (
                <img 
                  src={usaLink.imageLogo} 
                  alt={usaLink.name} 
                  className="lien-utile-logo"
                  onError={(e) => {
                    console.warn('❌ Image USA non chargée:', usaLink.imageLogo);
                    e.target.style.display = 'none'; 
                  }}
                />
              ) : (
                <div style={{ height: '50px' }}></div> 
              )}
              <p className="lien-utile-text">{usaLink.name}</p>
              <FaArrowUp className="lien-utile-icon" />
            </div>
            <a
              href={usaLink.linkAccess}
              target="_blank"
              rel="noopener noreferrer"
              className="lien-utile-link-custom"
              style={{
                display: 'block',
                backgroundColor: '#1a3c5e',
                color: 'white',
                padding: '8px',
                textAlign: 'center',
                textDecoration: 'none',
                marginTop: '5px',
                marginBottom: "-10px",
                transition: 'all 0.3s ease'
              }}
            >
              {t('lienUtile.officialWebsite')}
            </a>
          </div>
        )}
      </div>
    </div>
  );
}

export default LienUtile;